import styled, { keyframes } from 'styled-components';

// Widget principal do chat
export const ChatWidget = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 380px;
  height: ${props => props.isMinimized ? '70px' : '600px'};
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  transition: height 0.3s ease;
  overflow: hidden;
  border: 1px solid #e0e0e0;
`;

// Header do chat
export const ChatHeader = styled.div`
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 70px;
  box-sizing: border-box;
`;

export const ChatHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ChatAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ChatInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ChatTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
`;

export const ChatStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
`;

export const OnlineIndicator = styled.div`
  width: 8px;
  height: 8px;
  background: #4caf50;
  border-radius: 50%;
  border: 1px solid white;
`;

export const ChatControls = styled.div`
  display: flex;
  gap: 8px;
`;

export const ControlButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  i {
    font-size: 14px;
  }
`;

// Corpo do chat
export const ChatBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f8f9fa;
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 8px;
  justify-content: ${props => props.isUser ? 'flex-end' : 'flex-start'};
`;

export const BotAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  margin-top: 4px;
`;

export const Message = styled.div`
  max-width: 280px;
  padding: 12px 16px;
  border-radius: ${props => props.isUser ? '16px 16px 4px 16px' : '16px 16px 16px 4px'};
  background: ${props => props.isUser ? '#1e88e5' : 'white'};
  color: ${props => props.isUser ? 'white' : '#333'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  word-wrap: break-word;
  line-height: 1.4;
  font-size: 14px;
  
  ${props => !props.isUser && `
    border: 1px solid #e0e0e0;
  `}
`;

export const MessageContent = styled.div`
  margin: 0;
  line-height: 1.6;
  
  /* Espaçamento para parágrafos em mensagens do bot */
  br + br {
    margin-bottom: 8px;
  }
  
  /* Destaque para texto que começa com números (listas) */
  & > span:first-child {
    display: block;
  }
`;

// Tela de boas-vindas
export const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px 20px;
  text-align: center;
`;

export const WelcomeAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 20px;
`;

export const WelcomeText = styled.div`
  h4 {
    color: #333;
    margin-bottom: 12px;
    font-size: 18px;
    font-weight: 600;
  }
  
  p {
    color: #666;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.5;
    
    &:last-child {
      margin-bottom: 0;
      font-weight: 500;
      color: #1e88e5;
    }
  }
`;

// Opções rápidas
export const QuickOptions = styled.div`
  padding: 0 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuickOptionButton = styled.button`
  background: white;
  border: 1px solid #1e88e5;
  color: #1e88e5;
  padding: 12px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  
  &:hover {
    background: #1e88e5;
    color: white;
  }
`;

// Indicador de digitação
const typing = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-8px);
  }
`;

export const TypingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 0;
  
  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #1e88e5;
    animation: ${typing} 1.4s infinite ease-in-out;
    
    &:nth-child(1) {
      animation-delay: -0.32s;
    }
    
    &:nth-child(2) {
      animation-delay: -0.16s;
    }
    
    &:nth-child(3) {
      animation-delay: 0;
    }
  }
`;

// Footer do chat
export const ChatFooter = styled.div`
  background: white;
  border-top: 1px solid #e0e0e0;
`;

export const InputContainer = styled.div`
  padding: 16px 20px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

export const ChatInput = styled.input`
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 12px 16px;
  font-size: 14px;
  outline: none;
  resize: none;
  background: #f8f9fa;
  
  &:focus {
    border-color: #1e88e5;
    background: white;
  }
  
  &::placeholder {
    color: #999;
  }
`;

export const SendButton = styled.button`
  background: #1e88e5;
  border: none;
  color: white;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  position: relative;
  
  &:hover:not(:disabled) {
    background: #1565c0;
    transform: scale(1.05);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
  
  i {
    font-size: 16px;
    line-height: 1;
  }
`;

// Botão flutuante
export const FloatingButton = styled.button`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(30, 136, 229, 0.4);
  transition: all 0.3s ease;
  z-index: 999;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(30, 136, 229, 0.6);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  i {
    transition: transform 0.3s ease;
  }
  
  &:hover i {
    transform: scale(1.1);
  }
`;

export const FloatingButtonBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  background-color: #dc3545;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: white;
  border: 2px solid white;
`;

// Componentes legados (mantidos para compatibilidade)
export const ChatContainer = styled.div`
  height: 500px;
  display: flex;
  flex-direction: column;
`;

export const MessageTime = styled.div`
  font-size: 11px;
  opacity: 0.7;
  text-align: right;
`;